/* eslint-disable import/no-cycle */ var $4aad5201d967dce3$exports = {};
var $a2e48bfd9d5fe1db$exports = {};
var $7184b940deb17c68$exports = {};
const $7184b940deb17c68$var$checkRGBValidity = (num)=>{
    if (typeof num !== 'number') throw new TypeError('num must be a number');
    return num >= 0 && num <= 255;
};
const $7184b940deb17c68$var$isInteger = (value)=>typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
const $7184b940deb17c68$var$componentToHex = (rgbVal)=>{
    if (typeof rgbVal !== 'number') throw new TypeError('rgbVal must be a number');
    if (rgbVal < 0 || rgbVal > 255 || !$7184b940deb17c68$var$isInteger(rgbVal)) throw new Error('rgbVal must be an integer between 0 and 255, inclusive');
    const hex = rgbVal.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
};
const $7184b940deb17c68$var$convertRGBToHex = (r, g, b)=>`#${$7184b940deb17c68$var$componentToHex(r)}${$7184b940deb17c68$var$componentToHex(g)}${$7184b940deb17c68$var$componentToHex(b)}`;
const $7184b940deb17c68$var$convertHexToRGB = (hex)=>{
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    if (result === null) throw new Error('not a valid hex');
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};
$7184b940deb17c68$exports = {
    checkRGBValidity: $7184b940deb17c68$var$checkRGBValidity,
    convertRGBToHex: $7184b940deb17c68$var$convertRGBToHex,
    convertHexToRGB: $7184b940deb17c68$var$convertHexToRGB,
    componentToHex: $7184b940deb17c68$var$componentToHex,
    isInteger: $7184b940deb17c68$var$isInteger
};


var $a2e48bfd9d5fe1db$require$convertHexToRGB = $7184b940deb17c68$exports.convertHexToRGB;
var $a2e48bfd9d5fe1db$require$convertRGBToHex = $7184b940deb17c68$exports.convertRGBToHex;
var $1a76aafe89e93779$exports = {};

var $1a76aafe89e93779$require$checkRGBValidity = $7184b940deb17c68$exports.checkRGBValidity;
var $1a76aafe89e93779$require$isInteger = $7184b940deb17c68$exports.isInteger;
const $1a76aafe89e93779$var$makeStops = (size, startVal, endVal)=>{
    if (typeof size !== 'number') throw new TypeError('size must be a number');
    if (size < 2) throw new Error('size must be at least 2');
    if (!$1a76aafe89e93779$require$isInteger(size)) throw new Error('size must be an integer');
    // confirm that we're given a valid integer between 0 and 255, inclusive
    if (!$1a76aafe89e93779$require$checkRGBValidity(startVal) || !$1a76aafe89e93779$require$checkRGBValidity(endVal) || !$1a76aafe89e93779$require$isInteger(startVal) || !$1a76aafe89e93779$require$isInteger(endVal)) throw new Error('not a valid startVal or endVal');
    const stops = [];
    const lastElement = size - 1;
    // make the first element the startVal
    stops[0] = startVal;
    // make the last element the endVal
    stops[lastElement] = endVal;
    const stepVal = (endVal - startVal) / (size - 1) || 0;
    // start from what the second value should be since we already have the first
    let currVal = startVal + stepVal;
    // add the middle values to the array
    for(let i = 1; i <= size - 2; i += 1){
        stops[i] = Math.round(currVal);
        currVal += stepVal;
    }
    return stops;
};
$1a76aafe89e93779$exports = {
    makeStops: $1a76aafe89e93779$var$makeStops
};


var $a2e48bfd9d5fe1db$require$makeStops = $1a76aafe89e93779$exports.makeStops;
const $a2e48bfd9d5fe1db$var$makeRow = (length, startColor, endColor)=>{
    const row = new Array(length);
    const startColorRGB = $a2e48bfd9d5fe1db$require$convertHexToRGB(startColor);
    const endColorRGB = $a2e48bfd9d5fe1db$require$convertHexToRGB(endColor);
    const rStops = $a2e48bfd9d5fe1db$require$makeStops(length, startColorRGB.r, endColorRGB.r);
    const gStops = $a2e48bfd9d5fe1db$require$makeStops(length, startColorRGB.g, endColorRGB.g);
    const bStops = $a2e48bfd9d5fe1db$require$makeStops(length, startColorRGB.b, endColorRGB.b);
    for(let i = 0; i < row.length; i += 1)row[i] = $a2e48bfd9d5fe1db$require$convertRGBToHex(rStops[i], gStops[i], bStops[i]);
    return row;
};
const $a2e48bfd9d5fe1db$var$makeColorMixRow = (length, modeSelect, startColor, endColor)=>{
    const mixPercentageArray = $a2e48bfd9d5fe1db$require$makeStops(length, 0, 100);
    const row = new Array(length);
    for(let i = 0; i < row.length; i += 1)row[i] = `color-mix(in ${modeSelect}, ${startColor} ${100 - mixPercentageArray[i]}%, ${endColor} ${mixPercentageArray[i]}%)`;
    return row;
};
$a2e48bfd9d5fe1db$exports = {
    makeRow: $a2e48bfd9d5fe1db$var$makeRow,
    makeColorMixRow: $a2e48bfd9d5fe1db$var$makeColorMixRow
};


var $4aad5201d967dce3$require$makeRow = $a2e48bfd9d5fe1db$exports.makeRow;
var $4aad5201d967dce3$require$makeColorMixRow = $a2e48bfd9d5fe1db$exports.makeColorMixRow;
const $4aad5201d967dce3$var$makeGrid = (gridSize, modeSelect, topLeftColor, topRightColor, bottomLeftColor, bottomRightColor)=>{
    const grid = [];
    const firstRow = 0;
    const lastRow = gridSize - 1;
    grid[firstRow] = modeSelect === 'rgb' ? $4aad5201d967dce3$require$makeRow(gridSize, topLeftColor, topRightColor) : $4aad5201d967dce3$require$makeColorMixRow(gridSize, modeSelect, topLeftColor, topRightColor);
    grid[lastRow] = modeSelect === 'rgb' ? $4aad5201d967dce3$require$makeRow(gridSize, bottomLeftColor, bottomRightColor) : $4aad5201d967dce3$require$makeColorMixRow(gridSize, modeSelect, bottomLeftColor, bottomRightColor);
    // loop over each index and make an array representing the column
    for(let i = 0; i < gridSize; i += 1){
        const column = modeSelect === 'rgb' ? $4aad5201d967dce3$require$makeRow(gridSize, grid[firstRow][i], grid[lastRow][i]) : $4aad5201d967dce3$require$makeColorMixRow(gridSize, modeSelect, grid[firstRow][i], grid[lastRow][i]);
        for(let j = 1; j <= lastRow - 1; j += 1){
            // if grid[j] doesn't exist yet create it
            if (!grid[j]) grid[j] = [];
            // take j index of column and set it to the i index in the array that is the j index
            grid[j][i] = column[j];
        }
    }
    return grid;
};
$4aad5201d967dce3$exports = {
    makeGrid: $4aad5201d967dce3$var$makeGrid
};


function $53399d5603ac9c44$export$249696535a503013(className) {
    // removes the element if it already exists
    const currentElement = document.querySelector(className);
    if (currentElement) currentElement.remove();
}
function $53399d5603ac9c44$export$1e1c9bf5a4ffe0d1(parent) {
    while(parent.firstChild)parent.removeChild(parent.firstChild);
}
function $53399d5603ac9c44$export$4e142fbae5c3c70c() {
    const container = document.getElementsByClassName('cmp-color-grid')[0];
    container.innerHTML = '';
}
function $53399d5603ac9c44$export$cd663da2dbc235fb() {
    const form = document.querySelector('.cmp-color-form');
    form.classList.add('util-hidden');
}
function $53399d5603ac9c44$export$fd32f5f8d2981d76() {
    const form = document.querySelector('.cmp-color-form');
    form.classList.remove('util-hidden');
}
function $53399d5603ac9c44$export$a2a1e8c320d4e05d() {
    const form = document.querySelector('.cmp-color-form');
    form.reset();
}
function $53399d5603ac9c44$export$844b39041c7b680c() {
    $53399d5603ac9c44$export$4e142fbae5c3c70c();
// maybe remove these?
// removeElementByClass('.play-button');
// removeElementByClass('.winner-header');
}
function $53399d5603ac9c44$export$aed724be7924880(name, value) {
    const root = document.querySelector(':root');
    root.style.setProperty(name, value);
}
function $53399d5603ac9c44$export$4c16d78b7b453fcd(message) {
    const paragraph = document.querySelector('.cmp-header__paragraph');
    paragraph.innerHTML = message;
}
function $53399d5603ac9c44$export$551f0fa190fb11bc(size) {
    const root = document.querySelector(':root');
    root.style.setProperty('--size', size);
}


function $7451efa2902cd53a$export$61c18323487eae52() {
    (0, $53399d5603ac9c44$export$4c16d78b7b453fcd)('You Win!');
}


function $9f20254cec2b2a7c$var$markTileCorrect(tileIndex) {
    const tile = document.querySelector(`.cmp-color-grid__tile[data-tile-number = '${tileIndex}'`);
    tile.classList.add('cmp-color-grid__tile--correct');
}
function $9f20254cec2b2a7c$export$7601ebd7d9b3975b(currentGrid, answerKey) {
    let numberOfCorrectTiles = 0;
    for(let i = 0; i < answerKey.length; i += 1)if (answerKey[i] === currentGrid[i]) {
        numberOfCorrectTiles += 1;
        $9f20254cec2b2a7c$var$markTileCorrect(i);
    }
    if (numberOfCorrectTiles === currentGrid.length) (0, $7451efa2902cd53a$export$61c18323487eae52)();
}


var $28b5f9f6339a9a3b$exports = {};
// contains functions to duplicate, flatten, unflatten, and shuffle the grid
function $28b5f9f6339a9a3b$var$duplicateGrid(grid) {
    const result = [];
    grid.forEach((row, gridIndex)=>{
        const newRow = [];
        row.forEach((color, rowIndex)=>{
            newRow[rowIndex] = color;
        });
        result[gridIndex] = newRow;
    });
    return result;
}
function $28b5f9f6339a9a3b$var$flattenGrid(grid) {
    const result = [];
    grid.forEach((row)=>{
        row.forEach((color)=>{
            result.push(color);
        });
    });
    return result;
}
function $28b5f9f6339a9a3b$var$shuffle(arr) {
    for(let i = arr.length - 1; i > 0; i -= 1){
        const j = Math.floor(Math.random() * (i + 1));
        // eslint-disable-next-line no-param-reassign
        [arr[i], arr[j]] = [
            arr[j],
            arr[i]
        ];
    }
    return arr;
}
function $28b5f9f6339a9a3b$var$flatToMultiDimensional(flatGrid) {
    const rowSize = Math.sqrt(flatGrid.length);
    const multiDimensionalGrid = new Array(rowSize);
    for(let i = 0; i < multiDimensionalGrid.length; i += 1)multiDimensionalGrid[i] = new Array(rowSize);
    let outerIndex = 0;
    let innerIndex = 0;
    for(let i = 0; i < flatGrid.length; i += 1){
        multiDimensionalGrid[outerIndex][innerIndex] = flatGrid[i];
        innerIndex += 1;
        if (innerIndex % rowSize === 0) {
            outerIndex += 1;
            innerIndex = 0;
        }
    }
    return multiDimensionalGrid;
}
function $28b5f9f6339a9a3b$var$getCorners(flatGrid) {
    const gridSize = Math.sqrt(flatGrid.length);
    return {
        topLeft: {
            flatGridIndex: 0,
            color: flatGrid[0]
        },
        topRight: {
            flatGridIndex: gridSize - 1,
            color: flatGrid[gridSize - 1]
        },
        bottomLeft: {
            flatGridIndex: flatGrid.length - gridSize,
            color: flatGrid[flatGrid.length - gridSize]
        },
        bottomRight: {
            flatGridIndex: flatGrid.length - 1,
            color: flatGrid[flatGrid.length - 1]
        }
    };
}
function $28b5f9f6339a9a3b$var$removeCornersFromFlatGrid(flatGrid, corners) {
    const cornerPositionNamesReversed = Object.keys(corners).reverse();
    cornerPositionNamesReversed.forEach((positionName)=>{
        const indexToDelete = corners[positionName].flatGridIndex;
        flatGrid.splice(indexToDelete, 1);
    });
}
function $28b5f9f6339a9a3b$var$addCornersToFlatGrid(shuffledFlatGrid, corners) {
    const cornerPositionNames = Object.keys(corners);
    cornerPositionNames.forEach((positionName)=>{
        const indexToInsertAt = corners[positionName].flatGridIndex;
        const colorToInsert = corners[positionName].color;
        shuffledFlatGrid.splice(indexToInsertAt, 0, colorToInsert);
    });
}
function $28b5f9f6339a9a3b$var$shuffleGrid(grid) {
    const flatGrid = $28b5f9f6339a9a3b$var$flattenGrid(grid);
    const corners = $28b5f9f6339a9a3b$var$getCorners(flatGrid);
    $28b5f9f6339a9a3b$var$removeCornersFromFlatGrid(flatGrid, corners);
    const shuffledFlatGrid = $28b5f9f6339a9a3b$var$shuffle(flatGrid);
    $28b5f9f6339a9a3b$var$addCornersToFlatGrid(shuffledFlatGrid, corners);
    return $28b5f9f6339a9a3b$var$flatToMultiDimensional(shuffledFlatGrid);
}
$28b5f9f6339a9a3b$exports = {
    duplicateGrid: $28b5f9f6339a9a3b$var$duplicateGrid,
    flattenGrid: $28b5f9f6339a9a3b$var$flattenGrid,
    shuffleGrid: $28b5f9f6339a9a3b$var$shuffleGrid,
    flatToMultiDimensional: $28b5f9f6339a9a3b$var$flatToMultiDimensional,
    shuffle: $28b5f9f6339a9a3b$var$shuffle
};


let $f63bd137c9f1e22b$var$flatAnswerKey = null;
function $f63bd137c9f1e22b$export$8a9e2a13fbf8faaf() {
    $f63bd137c9f1e22b$var$flatAnswerKey = null;
}
function $f63bd137c9f1e22b$export$be94ac4d42d236f3(answerKey) {
    $f63bd137c9f1e22b$var$flatAnswerKey = answerKey;
}
function $f63bd137c9f1e22b$export$994e136483f2b7c7(grid) {
    (0, $9f20254cec2b2a7c$export$7601ebd7d9b3975b)((0, $28b5f9f6339a9a3b$exports.flattenGrid)(grid), $f63bd137c9f1e22b$var$flatAnswerKey);
}



function $43b3b0bb4270058d$export$e9c13da91cc5f72a(grid) {
    const container = document.querySelector('.cmp-color-grid');
    (0, $53399d5603ac9c44$export$1e1c9bf5a4ffe0d1)(container);
    grid.forEach((row, rowIndex)=>{
        const colorRow = document.createElement('div');
        colorRow.classList.add('cmp-color-grid__row');
        container.appendChild(colorRow);
        row.forEach((color, tileIndex)=>{
            const colorTile = document.createElement('div');
            const tileNumber = rowIndex * grid.length + tileIndex;
            colorRow.appendChild(colorTile);
            colorTile.style.backgroundColor = color;
            colorTile.classList.add('cmp-color-grid__tile');
            colorTile.dataset.tileNumber = tileNumber;
        });
    });
}



function $7dba09b1da830427$export$dff72a5fd5ad3e0c() {
    const navigation = document.createElement('nav');
    navigation.classList.add('cmp-navigation');
    const colorGridContainer = document.querySelector('.cmp-color-grid');
    colorGridContainer.after(navigation);
}
function $7dba09b1da830427$export$5ed005654107a9fc() {
    (0, $53399d5603ac9c44$export$249696535a503013)('.cmp-navigation');
}


function $0e8f8ad55368df4f$var$createButton(buttonType) {
    const button = document.createElement('button');
    button.innerHTML = buttonType.innerHTML;
    button.setAttribute('title', buttonType.description);
    button.classList.add('cmp-button');
    button.classList.add(buttonType.className);
    return button;
}
function $0e8f8ad55368df4f$var$removeButton(buttonType) {
    const button = document.querySelector(`.${buttonType.className}`);
    if (button) {
        button.removeEventListener('click', buttonType.callBack);
        button.remove();
    }
}
function $0e8f8ad55368df4f$var$addButtonClickListener(buttonType, grid) {
    const button = document.querySelector(`.${buttonType.className}`);
    if (grid) button.addEventListener('click', ()=>buttonType.callBack(grid));
    else // but why??
    button.addEventListener('click', buttonType.callBack);
}
function $0e8f8ad55368df4f$var$addButtonToNav(button) {
    const navigation = document.querySelector('.cmp-navigation');
    navigation.appendChild(button);
}
function $0e8f8ad55368df4f$var$addButton(buttonInfo, grid) {
    const button = $0e8f8ad55368df4f$var$createButton(buttonInfo);
    $0e8f8ad55368df4f$var$addButtonToNav(button);
    $0e8f8ad55368df4f$var$addButtonClickListener(buttonInfo, grid);
}
function $0e8f8ad55368df4f$var$addButtonList(buttonsList, buttonInfo, grid) {
    buttonsList.forEach((buttonType)=>{
        $0e8f8ad55368df4f$var$addButton(buttonInfo[buttonType], grid);
    });
}
function $0e8f8ad55368df4f$var$removeButtonList(buttonsList, buttonInfo) {
    buttonsList.forEach((buttonType)=>{
        $0e8f8ad55368df4f$var$removeButton(buttonInfo[buttonType]);
    });
}
function $0e8f8ad55368df4f$export$b335b7461bfbf838(buttonsList, buttonInfo, grid) {
    const allButtonsList = Object.keys(buttonInfo);
    const buttonsToRemove = [];
    allButtonsList.forEach((buttonType)=>{
        if (!buttonsList.includes(buttonType)) buttonsToRemove.push(buttonType);
    });
    $0e8f8ad55368df4f$var$addButtonList(buttonsList, buttonInfo, grid);
    $0e8f8ad55368df4f$var$removeButtonList(buttonsToRemove, buttonInfo);
}



function $596b24426c7c25dd$var$getFormDefaults() {
    const colorInputs = document.querySelectorAll(".cmp-color-form input[type='color']");
    // this next line needs to be refactored
    // eslint-disable-next-line max-len
    const [topLeft, topRight, bottomLeft, bottomRight] = [
        colorInputs[0].value,
        colorInputs[1].value,
        colorInputs[2].value,
        colorInputs[3].value
    ];
    const gridSize = document.querySelector('#grid-size').value;
    const modeSelect = document.querySelector('#mode-select').value;
    const formDefaults = {
        topLeft: topLeft,
        topRight: topRight,
        bottomLeft: bottomLeft,
        bottomRight: bottomRight,
        gridSize: gridSize,
        modeSelect: modeSelect
    };
    return formDefaults;
}
function $596b24426c7c25dd$export$26b7d5e3585b6b67() {
    const defaultFormValues = $596b24426c7c25dd$var$getFormDefaults();
    const { gridSize: gridSize, modeSelect: modeSelect, topLeft: topLeft, topRight: topRight, bottomLeft: bottomLeft, bottomRight: bottomRight } = defaultFormValues;
    const colorGrid = (0, $4aad5201d967dce3$exports.makeGrid)(Number(gridSize), modeSelect, topLeft, topRight, bottomLeft, bottomRight);
    return colorGrid;
}












let $6850edf340bfc450$var$initialClick = null;
function $6850edf340bfc450$var$switchTiles(firstIndex, secondIndex, currentGrid) {
    const flatGrid = (0, $28b5f9f6339a9a3b$exports.flattenGrid)(currentGrid);
    const savedColor = flatGrid[firstIndex];
    flatGrid[firstIndex] = flatGrid[secondIndex];
    flatGrid[secondIndex] = savedColor;
    $6850edf340bfc450$var$initialClick = null;
    (0, $1b3fdce81264cc01$export$311fbcbdfca0db50)((0, $28b5f9f6339a9a3b$exports.flatToMultiDimensional)(flatGrid));
}
function $6850edf340bfc450$var$handleClickTile(e, tileIndex, grid) {
    e.preventDefault();
    if (!$6850edf340bfc450$var$initialClick) {
        $6850edf340bfc450$var$initialClick = tileIndex;
        const tile = document.querySelector(`.cmp-color-grid__tile[data-tile-number = '${tileIndex}'`);
        tile.classList.add('cmp-color-grid__tile--first-click');
    } else $6850edf340bfc450$var$switchTiles($6850edf340bfc450$var$initialClick, tileIndex, grid);
}
function $6850edf340bfc450$export$54c501a4b462b6b(grid) {
    const tiles = document.querySelectorAll('.cmp-color-grid__tile');
    tiles.forEach((tile, index)=>{
        tile.addEventListener('click', (e)=>{
            if (!tile.classList.contains('cmp-color-grid__tile--correct')) $6850edf340bfc450$var$handleClickTile(e, index, grid);
        });
    });
}



function $1b3fdce81264cc01$export$311fbcbdfca0db50(grid) {
    (0, $43b3b0bb4270058d$export$e9c13da91cc5f72a)(grid);
    (0, $6850edf340bfc450$export$54c501a4b462b6b)(grid);
    (0, $f63bd137c9f1e22b$export$994e136483f2b7c7)(grid);
}
function $1b3fdce81264cc01$export$5f9f2982725d71d5(grid) {
    (0, $0e8f8ad55368df4f$export$b335b7461bfbf838)((0, $dc09e2655bf3129d$export$c716dbd358faee5e), (0, $dc09e2655bf3129d$export$bbea856fdb3e3c5f));
    (0, $53399d5603ac9c44$export$4c16d78b7b453fcd)('Put the grid back in order. Click on two tiles to switch their order.');
    (0, $f63bd137c9f1e22b$export$be94ac4d42d236f3)((0, $28b5f9f6339a9a3b$exports.flattenGrid)(grid));
    const duplicatedColorGrid = (0, $28b5f9f6339a9a3b$exports.duplicateGrid)(grid);
    const shuffledColorGrid = (0, $28b5f9f6339a9a3b$exports.shuffleGrid)(duplicatedColorGrid);
    (0, $43b3b0bb4270058d$export$e9c13da91cc5f72a)(shuffledColorGrid);
    (0, $6850edf340bfc450$export$54c501a4b462b6b)(shuffledColorGrid);
    (0, $f63bd137c9f1e22b$export$994e136483f2b7c7)(shuffledColorGrid);
}


const $dc09e2655bf3129d$export$bbea856fdb3e3c5f = {
    backToForm: {
        name: 'back to form',
        innerHTML: '< Change Grid',
        description: 'edit grid',
        className: 'cmp-navigation__back-to-form-button',
        callBack: (0, $b9980ee6405aa0d9$export$e820db9e9e2fc09b)
    },
    restartGame: {
        name: 'restart game',
        innerHTML: 'Restart Game',
        description: 'restart game with this grid',
        className: 'cmp-navigation__restart-game-button',
        callBack: (0, $8bd5163bccc8afe2$export$a47d254bccee23f)
    },
    play: {
        name: 'play',
        innerHTML: 'Start Game >',
        description: 'play game with this grid',
        className: 'cmp-navigation__play-button',
        callBack: (0, $1b3fdce81264cc01$export$5f9f2982725d71d5)
    },
    newGame: {
        name: 'new game',
        innerHTML: 'New Game',
        description: 'start over from the beginning',
        className: 'cmp-navigation__new-game-button',
        callBack: (0, $b9980ee6405aa0d9$export$1fe265bdd323f718)
    }
};
const $dc09e2655bf3129d$export$34c62ab6a35530db = [
    'backToForm',
    'play'
];
const $dc09e2655bf3129d$export$c716dbd358faee5e = [
    'restartGame',
    'newGame'
];


function $8bd5163bccc8afe2$export$a47d254bccee23f(grid) {
    let currentGrid;
    if (!grid.length) currentGrid = (0, $596b24426c7c25dd$export$26b7d5e3585b6b67)();
    else currentGrid = grid;
    (0, $53399d5603ac9c44$export$4c16d78b7b453fcd)('Here is your grid. Want to play a game with this grid?');
    (0, $53399d5603ac9c44$export$cd663da2dbc235fb)();
    (0, $f63bd137c9f1e22b$export$8a9e2a13fbf8faaf)();
    (0, $7dba09b1da830427$export$5ed005654107a9fc)();
    (0, $7dba09b1da830427$export$dff72a5fd5ad3e0c)(); // this must happen before fillColors
    (0, $0e8f8ad55368df4f$export$b335b7461bfbf838)((0, $dc09e2655bf3129d$export$34c62ab6a35530db), (0, $dc09e2655bf3129d$export$bbea856fdb3e3c5f), currentGrid);
    (0, $53399d5603ac9c44$export$4e142fbae5c3c70c)();
    (0, $53399d5603ac9c44$export$551f0fa190fb11bc)(currentGrid.length);
    (0, $43b3b0bb4270058d$export$e9c13da91cc5f72a)(currentGrid);
}


function $f3fdc121b976fe42$export$9643fd7297feaaf5(event) {
    const formData = new FormData(event.target);
    const [topLeft, topRight, bottomLeft, bottomRight, gridSize, modeSelect] = formData.values();
    return [
        topLeft,
        topRight,
        bottomLeft,
        bottomRight,
        gridSize,
        modeSelect
    ];
}
function $f3fdc121b976fe42$var$handleSubmit(event) {
    event.preventDefault();
    const [topLeft, topRight, bottomLeft, bottomRight, gridSize, modeSelect] = $f3fdc121b976fe42$export$9643fd7297feaaf5(event);
    const colorGrid = (0, $4aad5201d967dce3$exports.makeGrid)(Number(gridSize), modeSelect, topLeft, topRight, bottomLeft, bottomRight);
    (0, $8bd5163bccc8afe2$export$a47d254bccee23f)(colorGrid);
}
function $f3fdc121b976fe42$export$6c8b008bd8454dbf() {
    const form = document.getElementsByClassName('cmp-color-form')[0];
    form.addEventListener('submit', $f3fdc121b976fe42$var$handleSubmit);
}



const $e9584117a7e3fdc1$var$colors = {
    'top-left': '#ffffff',
    'top-right': '#ffffff',
    'bottom-left': '#ffffff',
    'bottom-right': '#ffffff'
};
function $e9584117a7e3fdc1$export$54f9144d64c1fe9b() {
    const submitButton = document.querySelector('.cmp-color-form__submit');
    submitButton.removeAttribute('disabled');
}
function $e9584117a7e3fdc1$var$validateColors() {
    const colorValues = Object.values($e9584117a7e3fdc1$var$colors);
    const colorsFrequency = {};
    // create a frequency table to see how many times each color appears
    colorValues.forEach((colorValue)=>{
        colorsFrequency[colorValue] = (colorsFrequency[colorValue] || 0) + 1;
    });
    // gives an array with numbers of times each color appears
    const frequencies = Object.values(colorsFrequency);
    // look for numbers greater than 1, if there are none, then enable submit
    if (!frequencies.find((num)=>num > 1)) $e9584117a7e3fdc1$export$54f9144d64c1fe9b();
}
function $e9584117a7e3fdc1$var$setColors(color, position) {
    $e9584117a7e3fdc1$var$colors[position] = color;
    $e9584117a7e3fdc1$var$validateColors();
}
function $e9584117a7e3fdc1$var$addInputListeners() {
    const colorForm = document.querySelector('.cmp-color-form');
    colorForm.addEventListener('input', (event)=>{
        $e9584117a7e3fdc1$var$setColors(event.target.value, event.target.id);
    });
}
function $e9584117a7e3fdc1$export$48bcc0d4b9a2b1f6() {
    $e9584117a7e3fdc1$var$addInputListeners();
    const submitButton = document.querySelector('.cmp-color-form__submit');
    submitButton.setAttribute('disabled', '');
}


const $5e27b272d49acb31$var$themes = [
    // [topleft, topright, bottomleft, bottomright],
    [
        '#ef476f',
        '#ffd166',
        '#06d6ad',
        '#118ab2'
    ],
    [
        '#f15bb5',
        '#fee440',
        '#00bbf9',
        '#00f5d4'
    ],
    [
        '#03045e',
        '#0077b6',
        '#00b4d8',
        '#90e0ef'
    ],
    [
        '#006466',
        '#144552',
        '#272640',
        '#4d194d'
    ],
    [
        '#355070',
        '#6d597a',
        '#e56b6f',
        '#eaac8b'
    ],
    [
        '#ffbe0b',
        '#fb5607',
        '#ff006e',
        '#8338ec'
    ],
    [
        '#ff6d00',
        '#ff9e00',
        '#240046',
        '#9d4edd'
    ],
    [
        '#99e264',
        '#036666',
        '#07beb8',
        '#c4fff9'
    ],
    [
        '#b7094c',
        '#0091ad',
        '#feecf3',
        '#ebfcff'
    ],
    [
        '#b7094c',
        '#0091ad',
        '#feecf3',
        '#ebfcff'
    ],
    [
        '#22577a',
        '#38a3a5',
        '#80ed99',
        '#57cc99'
    ],
    [
        '#0a0908',
        '#22333b',
        '#a9927d',
        '#f2f4f3'
    ],
    [
        '#fe7f2d',
        '#fcca46',
        '#233d4d',
        '#a1c181'
    ],
    [
        '#574ae2',
        '#222a68',
        '#ab81cd',
        '#654597'
    ],
    [
        '#392f5a',
        '#f092dd',
        '#eec8e0',
        '#ffaff0'
    ],
    [
        '#fa7921',
        '#fe9920',
        '#b9a44c',
        '#566e3d'
    ],
    [
        '#b6d094',
        '#e1aa7d',
        '#6a2e35',
        '#be8a60'
    ],
    [
        '#007bff',
        '#01563e',
        '#ae00ff',
        '#eeff00'
    ],
    [
        '#eac435',
        '#345995',
        '#03cea4',
        '#fb4d3d'
    ],
    [
        '#1a181b',
        '#564d65',
        '#3e8989',
        '#2cda9d'
    ],
    [
        '#dc1535',
        '#e9b320',
        '#43865b',
        '#3e2135'
    ],
    [
        '#f2f4f6',
        '#1ee3cf',
        '#6b48ff',
        '#0d3f67'
    ],
    [
        '#e41749',
        '#f5587b',
        '#ff8a5c',
        '#fff591'
    ],
    [
        '#de4307',
        '#f29c2b',
        '#f6d04d',
        '#8bc24c'
    ],
    [
        '#de6449',
        '#791e94',
        '#fffff2',
        '#41d3bd'
    ],
    [
        '#996699',
        '#cccccc',
        '#000000',
        '#006699'
    ],
    [
        '#03243a',
        '#558ad8',
        '#c5c5c5',
        '#74c239'
    ],
    [
        '#fffff5',
        '#ffda8e',
        '#80d4f6',
        '#5c196b'
    ],
    [
        '#d94e67',
        '#f2d8a7',
        '#a68572',
        '#73503c'
    ],
    [
        '#379392',
        '#4fb0c6',
        '#4f86c6',
        '#6c49b8'
    ],
    [
        '#ffcad4',
        '#b0d0d3',
        '#c08497',
        '#f7af9d'
    ],
    [
        '#ff8811',
        '#f4d06f',
        '#fff8f0',
        '#9dd9d2'
    ],
    [
        '#d68fd6',
        '#000009',
        '#defff2',
        '#417b5a'
    ],
    [
        '#f9f9f9',
        '#ffe45e',
        '#3fa8ee',
        '#5be6a5'
    ],
    [
        '#f89d0d',
        '#faf200',
        '#a8d5e2',
        '#548c2f'
    ],
    [
        '#f9fbef',
        '#daefb3',
        '#d64550',
        '#ea9e8d'
    ],
    [
        '#473198',
        '#66baa7',
        '#cac1eb',
        '#f1f9f7'
    ],
    [
        '#e0607e',
        '#f8dde3',
        '#c96748',
        '#eccac0'
    ],
    [
        '#68edc6',
        '#063728',
        '#3a53c7',
        '#0d1430'
    ],
    [
        '#d5b0ac',
        '#442622',
        '#cea0ae',
        '#43232c'
    ],
    [
        '#faebff',
        '#c200fb',
        '#fdc4dc',
        '#ec0868'
    ],
    [
        '#785964',
        '#82a7a6',
        '#2f2327',
        '#22302f'
    ],
    [
        '#090446',
        '#dbd8fd',
        '#eaa31f',
        '#fcf0da'
    ],
    [
        '#ffbc42',
        '#ba324f',
        '#fff8eb',
        '#eebfc9'
    ]
];
const $5e27b272d49acb31$var$inputIds = [
    'top-left',
    'top-right',
    'bottom-left',
    'bottom-right'
];
function $5e27b272d49acb31$var$setFormValue(id, value) {
    document.getElementById(id).value = value;
}
function $5e27b272d49acb31$var$getRandomItem(arr) {
    const randomIndex = Math.floor(Math.random() * (arr.length - 1));
    return arr[randomIndex];
}
function $5e27b272d49acb31$var$fillWithSurpriseTheme() {
    const surpriseTheme = $5e27b272d49acb31$var$getRandomItem($5e27b272d49acb31$var$themes);
    surpriseTheme.forEach((color, index)=>{
        $5e27b272d49acb31$var$setFormValue($5e27b272d49acb31$var$inputIds[index], color);
        (0, $e9584117a7e3fdc1$export$54f9144d64c1fe9b)();
    });
}
function $5e27b272d49acb31$export$f84f1b0cf6bdaf0b() {
    const button = document.querySelector('.cmp-color-form__surprise-me');
    button.addEventListener('click', $5e27b272d49acb31$var$fillWithSurpriseTheme);
}




const $b9980ee6405aa0d9$var$instructionalText = 'Pick your colors to begin or use the Surprise me button below.';
function $b9980ee6405aa0d9$export$e820db9e9e2fc09b() {
    (0, $7dba09b1da830427$export$5ed005654107a9fc)();
    (0, $53399d5603ac9c44$export$844b39041c7b680c)();
    (0, $53399d5603ac9c44$export$fd32f5f8d2981d76)();
    (0, $53399d5603ac9c44$export$4c16d78b7b453fcd)($b9980ee6405aa0d9$var$instructionalText);
    (0, $f3fdc121b976fe42$export$6c8b008bd8454dbf)();
    (0, $5e27b272d49acb31$export$f84f1b0cf6bdaf0b)();
}
function $b9980ee6405aa0d9$export$1fe265bdd323f718() {
    (0, $53399d5603ac9c44$export$a2a1e8c320d4e05d)();
    (0, $e9584117a7e3fdc1$export$48bcc0d4b9a2b1f6)();
    $b9980ee6405aa0d9$export$e820db9e9e2fc09b();
}


(0, $b9980ee6405aa0d9$export$1fe265bdd323f718)();


//# sourceMappingURL=repo.5d241c54.js.map
